<template>
    <div class="landing-page-testimonial 3xl:tw-max-w-[120rem] 3xl:tw-py-[7rem] 3xl:tw-px-[36.5rem] tw-h-full tw-py-12 tw-px-6 tw-w-full tw-bg-lightest-gray tw-flex tw-flex-col tw-justify-between tw-items-center">
        <p
                class="testimonial-title 3xl:tw-mb-[2.25rem] tw-text-[#064789] tw-text-center tw-font-poppins tw-text-base tw-font-bold tw-leading-normal tw-tracking-[0.125rem] tw-uppercase"
                :style="{color: baseColor}"
        >
            Testimonial
        </p>
        <p class="testimonial-description 3xl:tw-max-w-[46rem] 3xl:tw-text-[2.25rem] 3xl:tw-leading-[3.375rem] 3xl:tw-mb-[2rem] tw-text-[#161C2D] tw-text-center tw-font-poppins tw-text-xl tw-font-bold tw-leading-8 tw-max-w-xs">
            “Owning a home comes with its challenges, and keeping track of everything can feel like a daunting task. My home hub has truly simplified my life as a homeowner.”
        </p>
        <div class="testimonial-picture 3xl:tw-mb-[1.25rem] tw-max-h-44 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <img
                :src="require('./testimonial-user.png')"
                alt="Person"
                class="tw-w-[5.7rem] tw-h-[5.7rem] tw-object-cover tw-rounded-full"
            />
            <span class="testimonial-name tw-text-[#161C2D] tw-text-center tw-font-poppins tw-text-[1.25rem] tw-font-bold tw-leading-[2.16369rem]">
                Laura S.
            </span>
            <span class="testimonial-state tw-text-[#161C2D] tw-text-center tw-font-poppins tw-text-[1rem] tw-font-normal tw-leading-[1.93988rem] tw-opacity-65">
                Fort Worth, TX
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LandingPageTestimonial',
    components: {

    },
    mixins: [],
    props: {
        baseColor: {
            type: String,
            required: true,
        }
    },
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {

    }
}
</script>
